export default (state, action) => {
  switch (action.type) {
    case "Show_Tab_Data": {
      return {
        ...state,
        showTab: action.payload.show
        // Status: action.payload.status
      };
    }

    case "Email_Verification": {
      return {
        ...state,
        emailVerification: action.payload
      };
    }

    case "NAME_TEXT": {
      return { ...state, userName: action.payload };
    }
    case "HANDLE_SIDEBAR_TEXT":
      return { ...state, Header: action.payload };

    case "LOGGEDIN_USER_NAME":
      return { ...state, loggedInUserName: action.payload };

    case "LOGGEDIN_USERID":
      return { ...state, loggedInUserID: action.payload };

    case "ADD_NEW_CAMPAIGN":
      return { ...state, loggedInUserID: action.payload };

    case "ADD_LINKEDIN":
      return {
        ...state,
        addLinkedinStep: [...state.addLinkedinStep, action.modalData]
      };

    case "EDIT_LINKEDIN":
      return {
        ...state,
        addLinkedinStep: [...state.addLinkedinStep]
      };

    case "Delete_Result":
      const updateArray = state.addLinkedinStep.filter(
        addLinkedinStep => addLinkedinStep.linkedinemail !== action.LinkedinId
      );
      return {
        ...state,
        addLinkedinStep: updateArray
      };
    case "Delete_Result_Data":
      const updateArrayData = state.addLinkedinStep.filter(
        addLinkedinStep => addLinkedinStep.id !== action.LinkedinId
      );
      return {
        ...state,
        addLinkedinStep: updateArrayData
      };

    case "Edit_Linkedin_Data":
      return { ...state, addLinkedinStep: action.LinkedinId };

    case "Clear_Linkedin_Data": {
      return { ...state, addLinkedinStep: action.Linkedindata };
    }

    case "ADD_NEW_CAMPAIGN":
      return { ...state, loggedInUserID: action.payload };

    case "Form_data":
      return { ...state, formData: action.payload };

    case "ADD_STEP":
      return {
        ...state,
        addModalStep: [...state.addModalStep, action.modalData]
      };

    case "DELETE_ADDSTEPS":
      const updateStep = state.addModalStep.filter(
        addModalStep => addModalStep.stepname !== action.Modal_step
      );
      return {
        ...state,
        addModalStep: updateStep
      };

    case "Delete_Results_Data":
      const updateData = state.addModalStep.filter(
        addModalStep => addModalStep.id !== action.Modal_step
      );
      return {
        ...state,
        addModalStep: updateData
      };

    case "EDIT_MODAL_STEP":
      return { ...state, addModalStep: [...state.addModalStep] };

    case "Edit_Step_Data":
      return { ...state, addModalStep: action.StepId };

    case "Clear_ADD_STEP": {
      return { ...state, addModalStep: action.stepData };
    }
    case "STEPS_NAME": {
      return { ...state, stepName: action.stepname };
    }

    case "IsEditModeable": {
      return {
        ...state,
        isEditMode: action.editMode
      };
    }

    case "GetId": {
      return {
        ...state,
        id: action.id
      };
    }

    case "Last_Response": {
      return { ...state, selectDateResponse: action.payload };
    }

    case "Handle_CampaignId": {
      return { ...state, campaignId: action.payload };
    }

    case "Customer_Filter": {
      return { ...state, customerFilter: action.payload };
    }
    case "Campaign_Detail": {
      return { ...state, campaignDetail: action.payload };
    }
    case "CAMPAIGN_WORKFLOW_CLICK_TYPE": {
      return {
        ...state,
        campaignWorkflowClickType: action.payload
      };
    }

    default:
      return state;
  }
};
